<div class="mx-auto">
  <img src="assets/images/404.png" class="mx-auto"  alt="">
  <div class="text-center pb-10 mt-12 ">
  <a class="btn btn-primary" (click)="goHome()">Back to Home</a>
  </div>
</div>
